import React from "react";
import { formErrorClasses } from "../../styles/formClasses";

export function ErrorMessage({ message }: { message?: string }) {
  return message ? <p className={formErrorClasses}>{message}</p> : null;
}
